import React, { useEffect, useMemo, useState } from "react";
import MonthNav from "../../components/MonthNav";
import ResponsiveList from "../../components/ResponsiveList";
import api, { errMsg } from "../../core/api";
import { useApp } from "../../core/AppContext";
import { fa, formatLongDate, monthRange, normIso, todayIso, todayJ } from "../../core/format";

const FULL_LABEL = "شیفت ۲۴ ساعته";

// شیفت‌های کاری خود کاربر در ماه انتخاب‌شده؛ مرتب از روز اول به آخر ماه (بالا به پایین)
export default function MyShifts() {
  const { toast } = useApp();
  const tj = todayJ();
  const [ym, setYm] = useState({ y: tj.jy, m: tj.jm });
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const today = todayIso();

  useEffect(() => {
    const { from, to } = monthRange(ym.y, ym.m);
    setLoading(true);
    api
      .get("/shifts", { params: { from, to } })
      .then((r) => setItems(r.data.items || []))
      .catch((e) => toast(errMsg(e), "err"))
      .finally(() => setLoading(false));
  }, [ym, toast]);

  const rows = useMemo(
    () =>
      items
        .map((s) => ({ ...s, date: normIso(s.shiftDate) }))
        .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0)),
    [items],
  );

  const columns = [
    {
      key: "date",
      label: "تاریخ",
      render: (r) => <b>{formatLongDate(r.date)}</b>,
    },
    { key: "type", label: "نوع شیفت", render: () => FULL_LABEL },
    {
      key: "state",
      label: "وضعیت",
      render: (r) =>
        r.date === today ? (
          <span className="badge ok">امروز</span>
        ) : r.date < today ? (
          <span className="badge">گذشته</span>
        ) : (
          <span className="badge warn">پیش‌رو</span>
        ),
    },
  ];

  return (
    <>
      <div className="page-head">
        <div>
          <h2>شیفت کاری من</h2>
          <p>
            {loading ? "…" : `${fa(rows.length)} شیفت در این ماه`} — از روز یکم تا پایان ماه
          </p>
        </div>
        <MonthNav ym={ym} onChange={setYm} />
      </div>
      <ResponsiveList
        columns={columns}
        rows={rows}
        loading={loading}
        empty="برای این ماه شیفتی ثبت نشده است"
        rowClass={(r) => (r.date === today ? "row-today" : "")}
        mobileTitle={(r) => <b>{formatLongDate(r.date)}</b>}
        mobileMeta={() => [{ icon: "fa-regular fa-clock", label: "نوع شیفت", value: FULL_LABEL }]}
        mobileBadge={(r) =>
          r.date === today ? <span className="badge ok">امروز</span> : null
        }
      />
    </>
  );
}
